import type {Command, EditorView} from '@codemirror/view'

import {extractFenceSequence} from '../../../language-tools/markdown/code-block-utils'
import {MarkdownLine} from '../../../language-tools/markdown/markdown-line'
import {getNodeAtOffset} from '../../../language-tools/syntax-tree/node-range-utils'
import {isPositionedNode} from '../../../language-tools/syntax-tree/positioned-node'
import {getMarkdownTree} from '../../extensions/markdown-parser'

/**
 * Auto-closes code blocks when pressing Enter at the end of an opening fence.
 * Only triggers when the code block is open (no closing fence exists).
 */
export const closeCodeBlock: Command = (view: EditorView) => {
  if (view.state.selection.ranges.length !== 1 || !view.state.selection.main.empty) return false

  const source = view.state.doc.toString()
  const caretPosition = view.state.selection.main.anchor
  const tree = getMarkdownTree(view.state)

  const node = getNodeAtOffset(tree, caretPosition)
  if (node?.type !== 'code') return false

  const codeNode = node

  const caretLine = MarkdownLine.atOffset(tree, source, caretPosition)
  if (!caretLine) return false

  if (caretPosition !== caretLine.end) return false

  const openingFence = codeNode.children?.find(
    child => child.type === 'delimiter' && child.tokenType === 'codeFencedFence',
  )

  if (!openingFence || !isPositionedNode(openingFence) || !caretLine.contains(openingFence.position.start.offset))
    return false

  const fenceString = extractFenceSequence(openingFence.raw)
  if (!fenceString) return false

  view.dispatch({
    changes: [
      {
        from: caretPosition,
        insert: `\n\n${fenceString}`,
      },
    ],
    selection: {anchor: caretPosition + 1},
    userEvent: 'input.type',
    scrollIntoView: true,
  })

  return true
}
